module.exports = __webpack_public_path__ + "static/media/14436031405.507f7415.jpg";